
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"10.42 10.42 79.17 79.17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 41.477v28.977m1.705-40.908a1.705 1.705 0 11-3.41 0 1.705 1.705 0 013.41 0zM87.5 50c0 20.71-16.79 37.5-37.5 37.5S12.5 70.71 12.5 50 29.29 12.5 50 12.5 87.5 29.29 87.5 50z","stroke":"#0A203D","stroke-width":"4.167","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    